import { Nullable } from "common/types";
import { Record, Map, fromJS, List } from "immutable";
import { DateStringNumber } from ".";

export const webhookFromJSON = (json: Partial<IWebhookData>): WebhookRecord => {
  const record: IWebhookRecord = { ...(json as any) };

  record.auth_config = fromJS(json.auth_config || {});

  if (json.events) {
    record.events = List(json.events);
  }

  if (json.created_at) {
    record.created_at = new Date(json.created_at);
  }

  if (json.updated_at) {
    record.updated_at = new Date(json.updated_at);
  }

  return new WebhookRecord(record);
};

export interface IWebhookData {
  id: string;
  name: string;
  auth_config: any;
  auth_type: string;
  endpoint: string;
  events: Array<string>;
  status: string | null;
  org_id: string;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  loading?: boolean;
}

export interface IWebhookRecord {
  id: string;
  name: string;
  auth_config: Nullable<Map<string, any>>;
  auth_type: string;
  endpoint: Nullable<string>;
  events: List<string>;
  status: string;
  org_id: string;
  created_at: Date;
  updated_at: Date;
  loading: boolean;
}

export const defaultWebhookProps = {
  id: "",
  name: "",
  auth_config: null,
  auth_type: "none",
  endpoint: null,
  events: List<string>(),
  status: "",
  org_id: "",
  created_at: new Date(),
  updated_at: new Date(),
  loading: false,
};

export class WebhookRecord extends Record<IWebhookRecord>(defaultWebhookProps) implements IWebhookRecord {}
